import React, { useState } from "react";
import { Box, Button, Typography, Stack } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { ArtifactItem } from "../../../../../api/storage/storage";
import StorageBrowser, { StorageSelection } from "./StorageBrowser";

type Props = {
  label?: string;
  fileType?: "file" | "folder" | "zip" | "any";
  onSelect: (item: any) => void;
};

const ZIP_URL = /^https?:\/\/.+\.zip(\?.*)?$/i;

export const FrameworkPicker: React.FC<Props> = ({
  label = "Select a framework (ZIP, folder, or by URL)",
  fileType = "any",
  onSelect,
}) => {
  const [selection, setSelection] = useState<StorageSelection>(null);

  const allowSelect = (item: ArtifactItem) => {
    if (fileType === "zip") return item.type === "file" && item.name.endsWith(".zip");
    if (fileType === "folder") return item.type === "folder";
    if (fileType === "file") return item.type === "file";
    return item.type === "folder" || (item.type === "file" && item.name.endsWith(".zip"));
  };

  return (
    <Box>
      <Typography sx={{ fontWeight: 800, fontSize: 16, mb: 0.5 }}>{label}</Typography>
      <Typography color="text.secondary" sx={{ fontSize: 13, mb: 2 }}>
        Pick a framework ZIP or a folder from storage, or paste a direct .zip link.
      </Typography>

      <StorageBrowser
        allowSelect={allowSelect}
        enableFolderSelect
        urlPattern={ZIP_URL}
        urlPlaceholder="https://host/bucket/framework.zip"
        urlHint="Direct .zip URL"
        badgeFor={(item) =>
          item.type === "file" && item.name.endsWith(".zip")
            ? { label: "zip", color: "#e9672d" }
            : undefined
        }
        onChange={setSelection}
      />

      <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
        <Button
          variant="contained"
          endIcon={<ArrowForwardRoundedIcon />}
          onClick={() => selection && onSelect(selection)}
          disabled={!selection}
        >
          Continue
        </Button>
      </Stack>
    </Box>
  );
};

export default FrameworkPicker;
